var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wQHrEF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.498,
    height: 13.495,
    viewBox: "0 0 13.498 13.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M997.426,63.121a6.747,6.747,0,1,1,6.749-6.676A6.751,6.751,0,0,1,997.426,63.121Zm.053-1.463a3.633,3.633,0,0,0,.807-.055,5.312,5.312,0,0,0,3.565-8.138c-.112-.179-.117-.177-.263-.03l-7.1,7.1c-.152.152-.153.154.034.274A5.171,5.171,0,0,0,997.479,61.658Zm-5.342-5.274a5.221,5.221,0,0,0,.874,2.923c.077.12.125.143.237.03q3.562-3.571,7.131-7.135c.134-.134.135-.137-.028-.243a5.293,5.293,0,0,0-8.214,4.425Z",
    transform: "translate(-990.677 -49.626)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.a5d94a35b7fd42c739dfc5a930f70ef0.svg";
export { ForwardRef as ReactComponent };